export default __webpack_public_path__ + "static/media/vert.8f78fb9d.svg";